module.exports = __webpack_public_path__ + "img/mycombo_list_bg_img.8bf0c72c.png";